<div class="container modern-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fas fa-user-plus"></i>
      </div>
      <div class="header-text">
        <h2 class="page-title">Admissions</h2>
        <p class="page-subtitle">Join our prestigious pharmacy college - Admission guidelines and notifications</p>
      </div>
    </div>
  </div>

  <div class="card modern-card shadow-lg">
    <div class="card-body">
      <h5 class="card-title">
        <i class="fas fa-clipboard-list me-2"></i>Admission Notifications & Guidelines
      </h5>
      <hr class="title-divider">

      <div class="row">
        <div class="col-lg-12">
          <ul class="list-group modern-list">
            <li class="list-group-item modern-item" *ngFor="let link of advertiseList; let i=index">
              <div class="item-wrapper">
                <div class="item-icon">
                  <i class="fas fa-file-pdf"></i>
                  <span class="item-number">{{i + 1}}</span>
                </div>
                <div class="item-content">
                  <a [href]="link.filename" target="_blank" class="item-link">
                    {{link.displayText}}
                  </a>
                  <span class="item-meta">
                    <i class="fas fa-download"></i> Click to view or download
                  </span>
                </div>
                <div class="item-actions">
                  <button class="btn btn-sm btn-primary" data-bs-toggle="modal" [attr.data-bs-target]="'#admissionModal'+i">
                    <i class="fas fa-eye"></i> View
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Info Section -->
  <div class="row mt-4 info-section">
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-admission">
          <i class="fas fa-file-alt"></i>
        </div>
        <h5>Application Process</h5>
        <p>Complete online application and submit required documents for admission.</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-eligibility">
          <i class="fas fa-check-circle"></i>
        </div>
        <h5>Eligibility Criteria</h5>
        <p>Check admission requirements and eligibility for pharmacy programs.</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-dates">
          <i class="fas fa-calendar-alt"></i>
        </div>
        <h5>Important Dates</h5>
        <p>Stay updated with admission schedule and important deadlines.</p>
      </div>
    </div>
  </div>
</div>

<!-- PDF Viewer Modals - Outside container for proper z-index -->
<ng-container *ngFor="let link of advertiseList; let i=index">
  <app-pdf-viewer [title]="link.displayText" [url]="link.filename" [id]="'admissionModal'+i" [hideButton]="true"></app-pdf-viewer>
</ng-container>